/**
 * Panneau "Contact rapide" — compact side-panel pour actions immédiates.
 *
 * Affiché via open('quick', client). Liste les actions essentielles avec
 * un clic = ouverture de la modale correspondante.
 */
import React from 'react';
import { Sheet, SheetContent } from '../../ui/sheet';
import { Button } from '../../ui/button';
import {
  MessageCircle, Phone, Mail, ClipboardList, User, Send,
} from 'lucide-react';
import { useClientActions } from './ClientActionsContext';

const ITEMS = [
  { key: 'message', label: 'Message', icon: MessageCircle, primary: true },
  { key: 'call', label: 'Appeler', icon: Phone },
  { key: 'email', label: 'Email', icon: Mail },
  { key: 'task', label: 'Créer tâche', icon: ClipboardList },
  { key: 'view', label: 'Voir profil', icon: User },
];

export default function QuickContactPanel() {
  const { modal, client, close, switchModal } = useClientActions();
  const isOpen = modal === 'quick' && !!client;

  if (!isOpen) return null;

  return (
    <Sheet open={isOpen} onOpenChange={(o) => !o && close()}>
      <SheetContent
        side="right"
        className="w-72 sm:w-80 p-0 flex flex-col"
        data-testid="quick-contact-panel"
      >
        <div className="px-5 pt-5 pb-3 border-b border-gray-100">
          <h3 className="text-sm font-semibold text-gray-900 flex items-center gap-2">
            <Send className="w-4 h-4 text-emerald-600" /> Contact rapide
          </h3>
          {client && (
            <p className="text-xs text-gray-500 mt-1 truncate">{client.companyName}</p>
          )}
        </div>

        <div className="p-4 space-y-2">
          {ITEMS.map((it) => {
            const Icon = it.icon;
            if (it.primary) {
              return (
                <Button
                  key={it.key}
                  onClick={() => switchModal(it.key)}
                  className="w-full bg-emerald-600 hover:bg-emerald-700 text-white justify-start"
                  data-testid={`quick-${it.key}`}
                >
                  <Icon className="w-4 h-4 mr-2" /> {it.label}
                </Button>
              );
            }
            return (
              <Button
                key={it.key}
                variant="outline"
                onClick={() => switchModal(it.key)}
                className="w-full justify-start"
                data-testid={`quick-${it.key}`}
              >
                <Icon className="w-4 h-4 mr-2 text-gray-600" /> {it.label}
              </Button>
            );
          })}
        </div>

        <div className="mt-auto px-4 py-3 border-t border-gray-100">
          <Button variant="ghost" size="sm" onClick={close} className="w-full" data-testid="quick-close-btn">
            Fermer
          </Button>
        </div>
      </SheetContent>
    </Sheet>
  );
}
